export function tooltip() {
  $('.js-tooltip').on('click', function () {
    $('.js-tooltip_item').toggleClass('is-active');
  });
}